import CovaConfiguration from "./CovaConfiguration";

export default CovaConfiguration;
